import { forIn } from 'lodash';
/**
 * 替换模块实现
 * @param origin 原模块
 * @param newInstance 模块新实例
 */

export function swizzle(origin, newInstance) {
  forIn(origin, function (value, key) {
    var newValue = newInstance[key];
    if (!newValue) return;

    if (typeof value === 'function') {
      origin[key] = newValue.bind(newInstance);
    } else {
      origin[key] = newValue;
    }
  });
}